import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clone",
  "use": "clone-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol viewBox=\"0 0 15 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"clone\"><path d=\"M4 1c-.293 0-.572.063-.823.177A2 2 0 015 0h8a2 2 0 012 2v11a2 2 0 01-1.177 1.823c.114-.25.177-.53.177-.823V3a2 2 0 00-2-2H4zM2 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2H2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol